export default __webpack_public_path__ + "static/media/SS12-min.f45de778.jpg";